import { render } from "./Tipos_fallos.vue?vue&type=template&id=133d722c&scoped=true"
import script from "./Tipos_fallos.vue?vue&type=script&lang=js"
export * from "./Tipos_fallos.vue?vue&type=script&lang=js"

import "./Tipos_fallos.vue?vue&type=style&index=0&id=133d722c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133d722c"]])

export default __exports__